import { render, staticRenderFns } from "./ModalUserEdit.vue?vue&type=template&id=0bc3bad4&scoped=true&"
import script from "./ModalUserEdit.vue?vue&type=script&lang=js&"
export * from "./ModalUserEdit.vue?vue&type=script&lang=js&"
import style0 from "./ModalUserEdit.vue?vue&type=style&index=0&id=0bc3bad4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc3bad4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VButton: require('/home/circleci/repo/components/VButton.vue').default})
